<template>
    <div class="product-fabric-container">
        <!-- timeline之前的内容 -->
        <div class="product-fabric-wrapper">
            <div class="fabric-swipper-title">
                <!-- 页面顶部大标题 -->
                <CommonComponentsProductsTitleTopicTitle
                    :topic-title="pageData.topicTitle"
                    :color-index="pageData.topicTitleColorIndex"
                />
            </div>
            <div class="global-limited-1360px-container product-fabric-impression">
                <CommonComponentsProductsFabricImpression />
            </div>
        </div>
        <div class="global-limited-1360px-container">
            <CommonComponentsProductsFabricDigitalProcedure />
            <div class="gray-background">
                <CommonComponentsProductsFabricHardware />
            </div>
            <CommonComponentsProductsFabricDigitalRestoration />
            <div class="product-fabric-endingtitle">
                <CommonComponentsUnionTitleProductsEnding product-type="Fabric" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import i18n from '@/locales';

    const { t } = i18n.global;
    const pageData = {
        topicTitle: {
            title: t('global_swipper_title'),
            colorTitle: t('global_fabric_swipper_colorTitle_1'),
            subTitle: t('global_home_header_submenu_link_0_1_des_banner'),
        },
        topicTitleColorIndex: 1,
    };

    const fixBreakLine = () => {
        // 断句问题
        const isMobile = matchMobile();
        if (isMobile) {
            (document.querySelector('.topic-subtitle') as HTMLElement).innerHTML = t(
                'global_home_header_submenu_link_0_1_des',
            );
        }
    };

    onBeforeMount(() => {});

    onMounted(() => {
        fixBreakLine();
        addSlideInUp('.fabric-slide-in-up');
        // addSlideInDown('.fabric-slide-in-down');
        addFadeIn('.fabric-fade-in');
        // addTextScrollLine('.fabric-text-scroll');
        addTextScrollLine(
            '.fabric-text-scroll',
            { backgroundImage: 'linear-gradient(#BFBFBF, #BFBFBF)' },
            { color: 'rgba(255,255,255,0.8)' },
        );
    });
</script>

<style lang="less" scoped>
    .transition() {
        transition: all;
        transition: 0.5s;
    }

    .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex-vertical-center {
        display: flex;
        align-items: center;
    }

    .product-fabric-container {
        background-color: #000000;
        width: 100%;
        color: #fff;

        color: #fff;
        font-family: Montserrat, 'HarmonyOS Sans SC';
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        .product-fabric-wrapper {
            position: relative;
            display: flex;
            flex-direction: column;

            background-color: #000000;
            .fabric-swipper-title {
                padding-top: .convert(106px) [ @vw];
            }

            @media (max-width: @screen-mobile-width) {
                height: 100vh;
                .product-fabric-impression {
                    height: 100%;
                    width: 98%;
                }
            }
        }

        .product-fabric-timeline {
            margin-bottom: .convert(100px) [ @vw];
        }

        .gray-background {
            border-radius: 40px;
            background: #161616;
            padding: .convert(80px) [ @vw];
            margin-bottom: .convert(100px) [ @vw];

            @media (max-width: @screen-mobile-width) {
                border-radius: 20px;
            }
        }
        .product-fabric-endingtitle {
            z-index: 0;
            width: 100%;
            padding: .convert(100px) [ @vw] 0;
        }
    }
</style>
